export default function StepCard({
  stepNumber = 1,
  stepTitle = "Plan your actions",
  stepDescription = "The first step is to plan actions that feel manageable and will make a real impact on your farm.",
  buttonText = "PLAN YOUR ACTIONS",
  daysLeft = 122,
  status = "In progress",
  onButtonClick = () => {
    //do nothing
  },
}) {
  return (
    <div
      style={{
        maxWidth: "1100px",
        margin: "0 auto",
        padding: "16px",
      }}
    >
      <div
        style={{
          backgroundColor: "#FFFFFF",
          borderRadius: "24px",
          border: "1px solid #E0E0E0",
          padding: "40px 60px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
        }}
      >
        {/* Header Row */}
        {/* <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '24px'
                }}>
                   
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        fontSize: '24px',
                        fontWeight: 500
                    }}>
                        <span style={{
                            width: '32px',
                            height: '32px',
                            borderRadius: '50%',
                            border: '2px solid #000',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '16px',
                            fontWeight: 'bold'
                        }}>
                            $
                        </span>
                        <span>{status}</span>
                    </div>

                   
                    <div style={{
                        fontSize: '24px',
                        fontWeight: 500
                    }}>
                        {daysLeft} days left
                    </div>
                </div>

               
                <div style={{
                    width: '100%',
                    height: '12px',
                    backgroundColor: '#D9D9D9',
                    borderRadius: '6px',
                    overflow: 'hidden',
                    marginBottom: '48px',
                    display: 'flex',
                    gap: '8px'
                }}>
                    <div style={{ flex: 1, backgroundColor: '#D9D9D9', borderRadius: '6px' }} />
                    <div style={{ flex: 1, backgroundColor: '#D9D9D9', borderRadius: '6px' }} />
                    <div style={{ flex: 1, backgroundColor: '#D9D9D9', borderRadius: '6px' }} />
                    <div style={{ flex: 1, backgroundColor: '#D9D9D9', borderRadius: '6px' }} />
                    <div style={{ flex: 1, backgroundColor: '#D9D9D9', borderRadius: '6px' }} />
                </div>
                */}

        {/* Content */}
        <div
          style={{
            textAlign: "center",
            marginBottom: "20px",
          }}
        >
          <h2
            style={{
              fontSize: "20px",
              fontWeight: 700,
              margin: "0 0 16px 0",
              color: "#000",
            }}
          >
            Step {stepNumber}: {stepTitle}
          </h2>
          <p
            style={{
              fontSize: "18px",
              lineHeight: 1.2,
              color: "#000",
              margin: 0,
              maxWidth: "900px",
              marginLeft: "0px",
              marginRight: "0px",
            }}
          >
            {stepDescription}
          </p>
        </div>

        {/* Button */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <button
            onClick={onButtonClick}
            style={{
              backgroundColor: "#1C4321",
              color: "#FFFFFF",
              fontSize: "18px",
              fontWeight: 600,
              padding: "18px 20px",
              borderRadius: "12px",
              border: "none",
              cursor: "pointer",
              letterSpacing: "0.5px",
              transition: "all 0.2s ease",
              boxShadow: "0 4px 12px rgba(74, 124, 59, 0.3)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#000000ff";
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow =
                "0 6px 16px rgba(74, 124, 59, 0.4)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#1C4321";
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 4px 12px rgba(74, 124, 59, 0.3)";
            }}
          >
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  );
}

// Example usage:
// <StepCard
//   stepNumber={1}
//   stepTitle="Plan your actions"
//   stepDescription="The first step is to plan actions that feel manageable and will make a real impact on your farm."
//   buttonText="PLAN YOUR ACTIONS"
//   daysLeft={122}
//   status="In progress"
//   onButtonClick={() => console.log('Button clicked!')}
// />
